import { useTranslation } from 'react-i18next';

import SidePanelLink from './SidePanelLink';
import SidePanelTitle from './SidePanelTitle';

interface Props {
  hasMultiplePublications: boolean;
  hasAuthorsPage: boolean;
}

const GeneralNavGroup = ({ hasMultiplePublications, hasAuthorsPage }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col">
      <SidePanelTitle text={t('nav.links.home')} />
      <SidePanelLink path={'/'} text={t('meta.titles.posts')} />
      {hasMultiplePublications && <SidePanelLink path={'/publications'} text="Newsletters" />}
      {hasAuthorsPage && <SidePanelLink path={'/authors'} text={t('author.authors')} />}
    </div>
  );
};

export default GeneralNavGroup;
